<ng-container *ngIf="headerdata?.length > 0">
  <div class=" my-info">
    <div class="d-flex custom-padding">
      <button class="btn icon-btn level-icon order-1 order-md-2 d-md-none d-lg" [routerLink]="headerdata[0]?.menu_link">
        <img [src]="cdnImagePath + headerdata[0]?.icon_image" [alt]="headerdata[0]?.menu_name" width="17" height="19"
          loading="lazy" decoding="async">
      </button>
      <div class="tooltip-wrapper" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
        <button class="btn icon-btn order-2 order-md-1" (click)="onAccountButton()" aria-label="Account"
          data-bs-target="#myAccountOffcanvas" aria-controls="myAccountOffcanvas">
          <img [src]="cdnImagePath + headerdata[1]?.icon_image" class="user-icon" [alt]="headerdata[1]?.menu_name"
            width="17" height="19" loading="lazy" decoding="async" />
        </button>
        <div class="username-tooltip" *ngIf="tooltipVisible && username && !showdowntooltip">
          <div class="tooltip-arrow"></div>
          <div class="tooltip-content">
            <span class="greeting">Welcome, {{ username }}</span>
          </div>
        </div>
        <div class="username-tooltip-down" *ngIf="tooltipVisible && username && showdowntooltip">
          <div class="tooltip-arrow-down"></div>
          <div class="tooltip-content">
            <span class="greeting">Welcome, {{ username }}</span>
          </div>
        </div>
      </div>
    
     <!-- <button class="btn icon-btn d-none d-md-inline-block order-md-2" [routerLink]="headerdata[2]?.menu_link">
        <img [src]="cdnImagePath + headerdata[2]?.icon_image" [alt]="headerdata[2]?.menu_name" width="23" height="17"
          loading="lazy" decoding="async">
      </button>  -->

      <button class="btn icon-btn d-none d-md-inline-block position-relative wish-list-btn order-md-2 "
        [routerLink]="headerdata[3]?.menu_link"
        *ngIf="wishItems > 0">
       <img [src]="cdnImagePath + headerdata[3]?.icon_image" [alt]="headerdata[3]?.menu_name" width="23" height="17" loading="lazy" decoding="async">
       <span class="top-0 start-100 translate-middle badge badge-red ">
        {{ wishItems }}
        </span>
       </button>
      <button  class="btn icon-btn order-3 position-relative" type="button" (click)="openCartOffcanvas()"
        data-bs-toggle="offcanvas" data-bs-target="#shoppingCartOffcanvas" aria-controls="shoppingCartOffcanvas"
        aria-expanded="false">
        <img [src]="cdnImagePath + headerdata[4]?.icon_image" [alt]="headerdata[4]?.menu_name" width="24" height="21"
          loading="lazy" decoding="async">
        <span class="position-absolute top-0 start-100 translate-middle badge badge-red">{{ cartItems || 0 }}</span>
      </button>
    </div>
  </div>
  
</ng-container>